import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { IPermissionMapping } from "../../models/user";

export const PermissionMappingAdapter = createEntityAdapter<IPermissionMapping>({ selectId: (item: IPermissionMapping) => item.permissionId });

export interface PermissionMappingState extends EntityState<IPermissionMapping> {
  isLoaded?: boolean;
  message?: string | null;
  selectedItemId?: number;
}

export const intialPermissionMappingState: PermissionMappingState = PermissionMappingAdapter.getInitialState({
  isLoaded: false
});


const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = PermissionMappingAdapter.getSelectors();


export const selectAllPermissionMappings = selectAll;

export const selectAllPermissionMappingEntities = selectEntities;


export const getPermissionMappingIsLoaded = (state: PermissionMappingState) => state.isLoaded;
export const getPermissionMappingMessage = (state: PermissionMappingState) => state.message;
export const getPermissionMappingSelectedId = (state: PermissionMappingState) => state.selectedItemId;


